var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DepartmentFacts',{attrs:{"heading":_vm.data.heading || '',"updated-at":_vm.data.updatedAt || '',"cards":_vm.data.cards || [],"disclaimer":_vm.data.disclaimer || ''}})}
var staticRenderFns = []

export { render, staticRenderFns }